import { render } from "./ProsesPengujian.vue?vue&type=template&id=60c4a1d9"
import script from "./ProsesPengujian.vue?vue&type=script&lang=js"
export * from "./ProsesPengujian.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__